import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { ConfirmService } from '../../core/services/confirm.service';
import { SheetComponent } from './sheet.component';
import { BtnComponent } from './btn.component';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/**
 * Shell-mounted confirmation dialog driven by ConfirmService. Dismissing it
 * (scrim / cancel) answers `false`, so a caller always gets a decision.
 */
@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [NgIf, AsyncPipe, SheetComponent, BtnComponent, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-sheet *ngIf="confirm.request$ | async as req" [open]="true" (close)="answer(false)">
      <div style="padding:22px 20px 18px;text-align:center">
        <span style="width:54px;height:54px;border-radius:50%;margin:0 auto 14px;display:flex;align-items:center;justify-content:center"
          [style.background]="req.danger ? 'rgba(225,29,72,.12)' : 'var(--brand-tint)'">
          <app-icon [name]="req.danger ? 'solar:danger-triangle-bold' : 'solar:question-circle-bold'" [size]="26"
            [color]="req.danger ? 'var(--fr-danger)' : 'var(--brand-deep)'"></app-icon>
        </span>
        <div *ngIf="req.title" style="font-size:17px;font-weight:800;color:var(--fr-text);margin-bottom:7px">{{ req.title | t }}</div>
        <div style="font-size:14px;line-height:1.55;color:var(--fr-text-2)">{{ req.message | t }}</div>
      </div>
      <div sheetFooter style="display:flex;gap:10px;padding:0 20px 22px">
        <app-btn style="flex:1" variant="secondary" size="md" [full]="true" (act)="answer(false)">{{ req.cancelText | t }}</app-btn>
        <app-btn style="flex:1" [variant]="req.danger ? 'dark' : 'primary'" size="md" [full]="true" (act)="answer(true)">{{ req.confirmText | t }}</app-btn>
      </div>
    </app-sheet>`,
})
export class ConfirmDialogComponent {
  constructor(public confirm: ConfirmService) {}

  answer(ok: boolean): void { this.confirm.resolve(ok); }
}
